// transform curly quotes to normal quotes
export function withoutCurly(str: string): string {
  return str.replace(/[“”‘’]/g, (m) => TR[m] || m);
}

const TR: Record<string, string> = {
  "“": '"',
  "”": '"',
  "‘": "'",
  "’": "'",
};
